import { render } from "./ImageZoomComponent.vue?vue&type=template&id=67932c3e&scoped=true"
import script from "./ImageZoomComponent.vue?vue&type=script&lang=js"
export * from "./ImageZoomComponent.vue?vue&type=script&lang=js"

import "./ImageZoomComponent.vue?vue&type=style&index=0&id=67932c3e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67932c3e"]])

export default __exports__